import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { formatNumberDecimals } from 'utils/formats';

import CustomAsyncSelect from 'modules/_shared/components/CustomAsyncSelect';
import PartnerTypeahead from 'modules/_shared/components/PartnerTypeahead';
import InputText from 'modules/_shared/components/InputText';
import MandatoryField from 'modules/_shared/components/MandatoryField';

import { useAddDraftInvestorModal } from '../context/AddDraftInvestorModalContext';

const PartnerSection: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddDraftInvestorModal();

  return (
    <div className="form-group">
      <div className="row">
        <div className="col-6">
          <label className="form-label">{t('IsItCurrentlyAPartner?')}</label>
        </div>

        <div className="col-3">
          <div className="custom-control custom-radio">
            <input
              type="radio"
              className="custom-control-input"
              id="is-existent-partner-radio"
              checked={data.isExistentPartner}
              onChange={actions.handleChangeIsExistentPartner}
            />
            <label
              className="custom-control-label"
              htmlFor="is-existent-partner-radio"
            >
              {t('Yes')}
            </label>
          </div>
        </div>

        <div className="col-3">
          <div className="custom-control custom-radio">
            <input
              type="radio"
              className="custom-control-input"
              id="is-not-existent-partner-radio"
              checked={!data.isExistentPartner}
              onChange={actions.handleChangeIsExistentPartner}
            />
            <label
              className="custom-control-label"
              htmlFor="is-not-existent-partner-radio"
            >
              {t('Nope')}
            </label>
          </div>
        </div>
      </div>

      <div className="form-group">
        <label className="form-label" htmlFor="partner-name">
          {t('NameAndSurname')} <MandatoryField />
        </label>

        {data.isExistentPartner ? (
          <div className="form-control-wrap">
            <CustomAsyncSelect
              id="partner-select-input"
              value={data.selectedPartnerOption}
              onChange={actions.handleChangePartner}
              onFetchData={actions.handleSearchPartnerByTerm}
              placeholder={t('SearchPartner')}
              minimumInputLength={3}
              noDataLabelKey="NoPartnersHaveBeenFound"
              loadingLabelKey="LoadingPartners"
              errorLabelKey="ErrorLoadingPartners"
              defaultOptions={data.partnerOptions}
            />
          </div>
        ) : (
          <PartnerTypeahead
            naturalPerson
            defaultValue={data.name}
            onChangeName={actions.handleChangeName}
            onChangeCif={actions.handleChangeCif}
            onChangeEmail={actions.handleChangeEmail}
          />
        )}
        <span className="sub-text mt-1 mb-3">
          {data.selectedPartner &&
            t('ItHasSharesParticipations', {
              shares: data.partnerActualSharesCount,
              NDPercent: formatNumberDecimals(data.partnerNdPercent),
            })}
        </span>
      </div>

      <div className="form-group">
        <InputText
          id="cif"
          label={`${t('Nif')} (${t('Optional')})`}
          value={data.cif}
          icon="ni-cc-alt2"
          onChange={actions.handleChangeCif}
          disabled={data.isExistentPartner}
        />
      </div>

      <div className="form-group">
        <InputText
          id="email"
          label={`${t('Email')} (${t('Optional')})`}
          value={data.email}
          icon="ni-mail"
          onChange={actions.handleChangeEmail}
          emailInput
          disabled={data.isExistentPartner}
        />
      </div>
    </div>
  );
};

export default PartnerSection;
